export default {"src":"/_next/static/media/agreement_icon.b1d7f8bf.svg","height":14,"width":16,"blurWidth":0,"blurHeight":0};